import DashboardIcon from '@material-ui/icons/Dashboard';
import React, { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useAuth } from '../../auth';
import { ReactComponent as GitBookIcon } from '../../common/svg/sidebar/gitbook-icon.svg';
import { ReactComponent as BehindIcon } from '../../common/svg/sidebar/icon-behind.svg';
import { ReactComponent as BridgeIcon } from '../../common/svg/sidebar/icon-bridge.svg';
import { ReactComponent as GalleryIcon } from '../../common/svg/sidebar/icon-gallery.svg';
import { ReactComponent as MarketplaceIcon } from '../../common/svg/sidebar/icon-marketplace.svg';
import { ReactComponent as MintIcon } from '../../common/svg/sidebar/icon-mint.svg';
import { ReactComponent as MogieLandIcon } from '../../common/svg/sidebar/icon-mogieland.svg';
import { ReactComponent as MogiesIcon } from '../../common/svg/sidebar/icon-mogies.svg';
import { ReactComponent as SubmissionIcon } from '../../common/svg/sidebar/icon-project-submission.svg';
import { ReactComponent as RoadmapIcon } from '../../common/svg/sidebar/icon-roadmap.svg';
import { ReactComponent as ShowcaseIcon } from '../../common/svg/sidebar/icon-showcase.svg';
import { ReactComponent as SignOutIcon } from '../../common/svg/sidebar/icon-signout.svg';
import { ReactComponent as StakingIcon } from '../../common/svg/sidebar/icon-staking.svg';
import { ReactComponent as SwapIcon } from '../../common/svg/sidebar/icon-swap.svg';
import { ReactComponent as UtilityIcon } from '../../common/svg/sidebar/icon-utility.svg';
import { ReactComponent as VotingIcon } from '../../common/svg/sidebar/icon-voting.svg';
import { createBuyStarsModal } from '../../components/buy-stars-modal';
import { SidebarComponent } from '../../components/sidebar/Sidebar.component';
import { bridgeUrl, swapUrl } from '../../config';
import { ModalStateContext } from '../../contexts/app-state-context/modal-state.context';
import { getTargetOrigin } from '../../utils/window.util';
export interface Props {}

export const Sidebar: React.FC<Props> = () => {
  const { user, logout } = useAuth();
  const { setModal } = useContext(ModalStateContext);
  const location = useLocation();

  const handleClickGetMoreStars = () => {
    setModal(createBuyStarsModal());
  };

  const sidebarItems = [
    { title: 'Dashboard', href: '/platform/dashboard', icon: DashboardIcon },
    {
      title: 'Marketplace',
      href: '/platform/marketplace',
      icon: MarketplaceIcon,
    },
    { title: 'Showcase', href: '/platform/showcase', icon: ShowcaseIcon },
    { title: 'Staking', href: '/platform/starsStaking', icon: StakingIcon },
    { title: 'Bridge', href: bridgeUrl, icon: BridgeIcon },
    { title: 'Swap', href: swapUrl, icon: SwapIcon },
    { title: 'Voting', href: '/platform/voting', icon: VotingIcon },
    {
      title: 'Mogies',
      href: '/platform/mogie',
      icon: MogiesIcon,
      subtabs: [
        {
          title: 'Mint',
          href:
            /Android/i.exec(navigator.userAgent) ||
            /iPhone/i.exec(navigator.userAgent)
              ? getTargetOrigin() + '/mint'
              : '/platform/mogie/mint',
          icon: MintIcon,
        },
        {
          title: 'Mogieland',
          href: '/platform/mogie/mogieland',
          icon: MogieLandIcon,
        },
        {
          title: 'Behind The Scenes',
          href: '/platform/mogie/behindthescenes',
          icon: BehindIcon,
        },
        {
          title: 'Gallery',
          href: '/platform/mogie/gallery',
          icon: GalleryIcon,
        },
        {
          title: 'Utility',
          href: '/platform/mogie/utility',
          icon: UtilityIcon,
        },
        {
          title: 'Roadmap',
          href: '/platform/mogie/roadmap',
          icon: RoadmapIcon,
        },
      ],
    },
  ];

  const sidebarItemsBottom = [
    {
      title: 'Creators Dashboard',
      href: '/platform/creators/dashboard',
      icon: DashboardIcon,
    },
    {
      title: 'Gitbook',
      href: 'https://mogulproductions.gitbook.io/mogul-productions/',
      icon: GitBookIcon,
    },
    {
      title: 'Submit Project',
      href: '/platform/projectSubmission',
      icon: SubmissionIcon,
    },
    { title: 'Sign out', onClick: logout, icon: SignOutIcon },
    {
      title: 'Buy Mogul',
      onClick: handleClickGetMoreStars,
      button: true,
      type: 'secondary',
    },
  ];

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);

    if (searchParams.has('modal') && searchParams.get('modal') === 'buystars') {
      handleClickGetMoreStars();
    }
  }, [location]);

  return (
    <SidebarComponent
      menuItems={sidebarItems}
      menuItemsBottom={sidebarItemsBottom}
      profileImageSrc={user?.image?.publicUrl}
    />
  );
};
